import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEdit, faSync, faTrash, faPlus } from '@fortawesome/free-solid-svg-icons';
import { loadDynamicForm, handleSync, addDynamicForm } from "../../api/ajustesApi";

const Ajustes = () => {
    const navigate = useNavigate();
    const user = JSON.parse(sessionStorage.getItem('lgusr'));
    const isAdmin = user?.role === 'ADMIN';
    const orgId = user?.orgId;

    const [dyForms, setList] = useState([]);

    const fetchData = async () => {
        try {
            const res = await loadDynamicForm(orgId);
            console.log(res.data);
            return;

            setList(res.data);
        } catch (error) {
            console.error("Error loading data:", error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const getStatus = (status) => {
        return status === 1 ? 'Active' : 'Inactive';
    };

    const renderFieldDetails = (field) => {
        return (
            <div key={field.id} className="bg-white p-4 mb-4 rounded-lg shadow-sm">
                <div className="space-y-2">
                    <div><strong className="text-gray-700">Label:</strong> <span className="text-gray-900">{field.label}</span></div>
                    <div><strong className="text-gray-700">Type:</strong> <span className="text-gray-900">{field.type}</span></div>
                    <div><strong className="text-gray-700">Required:</strong> <span className={`text-sm ${field.required ? 'text-green-600' : 'text-red-600'}`}>{field.required ? 'Yes' : 'No'}</span></div>
                    <div><strong className="text-gray-700">Default Value:</strong> <span className="text-gray-900">{field.defaultValue || 'N/A'}</span></div>
                    <div><strong className="text-gray-700">Options:</strong> <span className="text-gray-900">{field.options || 'N/A'}</span></div>
                    <div><strong className="text-gray-700">Min Length:</strong> <span className="text-gray-900">{field.minLength}</span></div>
                    <div><strong className="text-gray-700">Max Length:</strong> <span className="text-gray-900">{field.maxLength}</span></div>
                </div>
            </div>
        );
    };

    return ( isAdmin &&
        <div className="bg-white p-8">
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-3xl font-semibold text-gray-800">Dynamic Form</h2>
                <button className="bg-orange-500 text-white px-6 py-2 rounded-lg hover:bg-orange-600 transition-all duration-300" onClick={() => navigate('/ajustes/new-dyform')}>
                    <FontAwesomeIcon icon={faPlus} className="mr-2" /> Add New Form
                </button>
            </div>
            <div className="overflow-hidden rounded-lg shadow-lg bg-blue-50">
                <table className="min-w-full divide-y divide-gray-300">
                    <thead className="bg-blue-100 text-gray-800">
                        <tr>
                            <th className="px-6 py-4 text-sm font-semibold text-left">Type</th>
                            <th className="px-6 py-4 text-sm font-semibold text-left">Details</th>
                            <th className="px-6 py-4 text-sm font-semibold text-left">Organization</th>
                            <th className="px-6 py-4 text-sm font-semibold text-left">Status</th>
                            <th className="px-6 py-4 text-sm font-semibold text-right">Actions</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                        {dyForms.map((ph) => (
                            <tr key={ph.id} className="hover:bg-blue-50 transition-all duration-300">
                                <td className="px-6 py-4 text-sm text-gray-800">{ph.selectedType}</td>
                                <td className="px-6 py-4 text-sm text-gray-600">
                                    {ph.fields.map((field) => renderFieldDetails(field))}
                                </td>
                                <td className="px-6 py-4 text-sm text-gray-800">{ph.organizationName}</td>
                                <td className="px-6 py-4 text-sm text-gray-800">
                                    <span className={`px-3 py-1 rounded-full text-sm ${ph.entityStatus === 1 ? 'bg-green-100 text-green-600' : 'bg-red-100 text-red-600'}`}>
                                        {getStatus(ph.entityStatus)}
                                    </span>
                                </td>
                                <td className="px-6 py-4 text-right space-x-2 text-sm">
                                    <button className="text-blue-600 hover:text-blue-800 transition-colors"><FontAwesomeIcon icon={faEye} /></button>
                                    <button className="text-green-600 hover:text-green-800 transition-colors"><FontAwesomeIcon icon={faEdit} /></button>
                                    <button className="text-yellow-600 hover:text-yellow-800 transition-colors" title="Generate View"><FontAwesomeIcon icon={faSync} /></button>
                                    <button className="text-yellow-600 hover:text-yellow-800 transition-colors" onClick={() => handleSync(ph.organizationId, ph.id)}>
                                        <FontAwesomeIcon icon={faSync} />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Ajustes;
